export const LOADING_FB_AD_ACCOUNTS = 'fb_ad_accounts/LOAD_FB_AD_ACCOUNTS'
export const LOADING_FB_AD_ACCOUNTS_SUCCESS = 'fb_ad_accounts/LOAD_FB_AD_ACCOUNTS_SUCCESS'
export const LOADING_FB_AD_ACCOUNTS_FAILURE = 'fb_ad_accounts/LOAD_FB_AD_ACCOUNTS_FAILURE'
